<template>
  <div>
    <b-form-checkbox
      v-model="changePassword"
      switch
    >
      Parola Belirle
    </b-form-checkbox>
    <template v-if="changePassword">
      <b-form-group
        label="Parola"
        label-for="new_password"
      >
        <validation-provider
          #default="{ errors }"
          name="Parola"
          rules="required"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="new_password"
              v-model="dataItem.new_password"
              :type="passwordFieldType"
              placeholder="Parola"
            />
            <b-input-group-append is-text>
              <feather-icon
                :icon="passwordToggleIcon"
                class="cursor-pointer"
                @click="togglePasswordVisibility"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </template>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BFormCheckbox, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  name: 'PasswordText',
  components: {
    ValidationProvider,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      changePassword: !this.$store.getters['drUsers/dataItem'].id,
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    dataItem() {
      return this.$store.getters['drUsers/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
